module.exports = __webpack_public_path__ + "static/media/c2.55f1e269.png";